/* Otaku Dreams sticky add-to-cart bar + phone options sheet.
   - Bar shows once the Add to cart button or the gallery has scrolled past; hides while the footer is on screen.
   - Desktop: inline variant select stays in sync with the main picker (both directions).
   - Phones: the button opens a bottom sheet with one select per option; the variant is resolved from the
     choices, price/image update live, and Dawn's own <product-form> does the add so the cart drawer opens. */
(function () {
  function money(format, cents, trimZeros) {
    var value = (Number(cents) || 0) / 100;
    var fixed = value.toFixed(2);
    var noDecimals = Math.round(value).toString();
    var amount = fixed.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (trimZeros && /\.00$/.test(amount)) amount = amount.replace(/\.00$/, '');
    return (format || '${{amount}}')
      .replace(/<[^>]*>/g, '')
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, fixed.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, noDecimals)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, fixed)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, fixed.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals_with_space_separator\s*\}\}/g, noDecimals);
  }

  function initSheet(sheet) {
    if (sheet.dataset.odInit) return;
    sheet.dataset.odInit = '1';
    if (sheet.parentElement !== document.body) document.body.appendChild(sheet);

    var variants = [];
    try {
      variants = JSON.parse(sheet.querySelector('[data-od-variants]').textContent);
    } catch (e) {}
    var format = sheet.dataset.moneyFormat;
    var selects = Array.prototype.slice.call(sheet.querySelectorAll('[data-sheet-option]'));
    var idInput = sheet.querySelector('input[name="id"]');
    var submit = sheet.querySelector('.od-sheet__submit');
    var submitText = submit && submit.querySelector('span');
    var now = sheet.querySelector('.od-sheet__price-now');
    var was = sheet.querySelector('.od-sheet__price-was');
    var img = sheet.querySelector('.od-sheet__image');
    var defaultLabel = submitText ? submitText.textContent : 'Add to cart';

    function resolve() {
      var opts = selects.map(function (s) { return s.value; });
      var v = variants.find(function (x) {
        return x.options.every(function (o, i) { return o === opts[i]; });
      });
      if (!v) {
        idInput.value = '';
        submit.setAttribute('disabled', 'disabled');
        if (submitText) submitText.textContent = (window.variantStrings && window.variantStrings.unavailable) || 'Unavailable';
        now.textContent = '';
        was.hidden = true;
        return null;
      }
      idInput.value = v.id;
      idInput.disabled = false;
      if (!v.available) {
        submit.setAttribute('disabled', 'disabled');
        if (submitText) submitText.textContent = (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
      } else {
        submit.removeAttribute('disabled');
        submit.removeAttribute('aria-disabled');
        if (submitText) submitText.textContent = defaultLabel;
      }
      now.textContent = money(format, v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) {
        was.textContent = money(format, v.compare_at_price);
        was.hidden = false;
      } else {
        was.hidden = true;
      }
      if (img && v.image) img.src = v.image;
      return v;
    }
    selects.forEach(function (s) { s.addEventListener('change', resolve); });
    sheet.querySelector('.od-sheet__close').addEventListener('click', function () { sheet.hide(); });

    // Keep the sheet aligned with whatever the main picker currently says.
    sheet.setFromVariant = function (v) {
      if (!v || !v.options) return;
      selects.forEach(function (s, i) { if (v.options[i] != null) s.value = v.options[i]; });
      resolve();
    };
    resolve();

    // When the cart drawer opens (Dawn adds .active), close the sheet and keep the page scroll locked for the drawer.
    var drawer = document.querySelector('cart-drawer');
    function closeSheet() {
      if (!sheet.hasAttribute('open')) return;
      if (typeof sheet.hide === 'function') sheet.hide();
      else sheet.removeAttribute('open');
      if (drawer && drawer.classList.contains('active')) document.body.classList.add('overflow-hidden');
    }
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(function () {
        if (drawer.classList.contains('active')) setTimeout(closeSheet, 50);
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(closeSheet, 300); });
    }
  }

  function init(bar) {
    if (bar.dataset.odInit) return;
    bar.dataset.odInit = '1';
    if (bar.parentElement !== document.body) document.body.appendChild(bar);

    var section = bar.dataset.section;
    var trigger = document.querySelector(bar.dataset.trigger) || document.querySelector('#ProductInfo-' + section);
    var mode = bar.dataset.show;
    var sheet = bar.dataset.sheet && document.querySelector(bar.dataset.sheet);
    if (sheet) initSheet(sheet);

    var media = document.querySelector('#MainProduct-' + section + ' .product__media-wrapper');
    if (mode === 'always' || !trigger || !('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      document.body.classList.add('od-sticky-open');
      document.documentElement.style.setProperty('--od-lift', bar.offsetHeight + 'px');
    } else {
      var passed = {};
      var footerInView = false;
      var apply = function () {
        var show = !!(passed.trigger || passed.media) && !footerInView;
        bar.classList.toggle('is-visible', show);
        document.body.classList.toggle('od-sticky-open', show);
        document.documentElement.style.setProperty('--od-lift', show ? bar.offsetHeight + 'px' : '0px');
      };
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            passed[e.target === trigger ? 'trigger' : 'media'] = !e.isIntersecting && e.boundingClientRect.bottom < 0;
          });
          apply();
        },
        { threshold: 0 }
      );
      io.observe(trigger);
      if (media) io.observe(media);
      var footer = document.querySelector('.footer') || document.getElementById('shopify-section-footer');
      if (footer) {
        new IntersectionObserver(
          function (entries) {
            entries.forEach(function (e) { footerInView = e.isIntersecting; });
            apply();
          },
          { threshold: 0 }
        ).observe(footer);
      }
    }

    // In theme preview Shopify injects a fixed bar at the bottom; sit above it.
    function clearPreviewBar() {
      var pb = document.getElementById('PBarNextFrameWrapper') || document.getElementById('preview-bar-iframe');
      if (!pb) return;
      var h = pb.getBoundingClientRect().height;
      if (h > 0) bar.style.bottom = h + 'px';
    }
    clearPreviewBar();
    setTimeout(clearPreviewBar, 1500);
    setTimeout(clearPreviewBar, 4000);

    var select = bar.querySelector('select[name="id"]');
    var hiddenId = bar.querySelector('input[name="id"]');
    var price = bar.querySelector('.od-sticky__price');
    var img = bar.querySelector('.od-sticky__image');
    var syncing = false;

    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var data = event && event.data;
        if (!data || data.sectionId !== section) return;
        var v = data.variant;
        if (!v) return;
        syncing = true;
        if (select) select.value = String(v.id);
        if (hiddenId) hiddenId.value = v.id;
        if (price && data.html) {
          var src = data.html.getElementById('price-' + section);
          if (src) price.innerHTML = src.innerHTML;
        }
        if (img && v.featured_image && v.featured_image.src) {
          img.src = v.featured_image.src.replace(/(\.[a-z]+)(\?.*)?$/i, '_160x$1$2');
        }
        if (sheet && sheet.setFromVariant) sheet.setFromVariant(v);
        syncing = false;
      });
    }

    if (select) {
      select.addEventListener('change', function () {
        if (syncing) return;
        var info = document.querySelector('product-info[data-section="' + section + '"]');
        if (!info || typeof info.renderProductInfo !== 'function') return;
        var url = info.dataset.url + '?variant=' + select.value + '&section_id=' + info.sectionId;
        try {
          info.renderProductInfo({
            requestUrl: url,
            targetId: select.id,
            callback: info.handleUpdateProductInfo(info.dataset.url),
          });
        } catch (e) {}
      });
    }
  }

  function run() {
    document.querySelectorAll('.od-sticky').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
})();
